import { getRequestInterceptorHandlers } from '../interceptors';
import handleResponse, { handleError } from './handleResponse';
import { getRequestBody, getURLWithParams } from './helper';

const globalHeaders = {};
const makeRequest = async (url, options = {}) => {
    const {
        mode = 'cors',
        credentials = 'include',
        headers = {},
        method,
        abortControllerCallback,
        timeout,
    } = options ?? {};

    const urlWithParams = getURLWithParams(url, options);
    const bodyToSend = getRequestBody(options);

    const controller = new AbortController();
    const { signal } = controller;

    let requestTimedout = false;
    let timeoutId;

    const fetchOptions = {
        mode: mode ?? 'cors',
        credentials: credentials ?? 'include',
        headers: new Headers({ ...globalHeaders, ...(headers ?? {}) }),
        body: bodyToSend,
        method,
    };

    if (typeof abortControllerCallback === 'function') {
        abortControllerCallback(controller);
    }

    if (timeout) {
        timeoutId = setTimeout(() => {
            requestTimedout = true;
            controller.abort();
        }, timeout);
    }

    let fetchConfig = {
        url: urlWithParams,
        options: fetchOptions,
    };

    try {
        const requestInterceptorHandlers = getRequestInterceptorHandlers();

        for (let i = 0; i < requestInterceptorHandlers.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            fetchConfig =
                // eslint-disable-next-line no-await-in-loop
                (await requestInterceptorHandlers[i].interceptorHandler(
                    fetchConfig,
                )) ?? fetchConfig;
        }

        fetchConfig.options.signal = signal;

        const httpResponse = await fetch(fetchConfig.url, fetchConfig.options);

        const requestConfig = {
            url,
            options,
        };

        const response = await handleResponse(httpResponse, requestConfig);

        return response;
    } catch (err) {
        handleError(err, requestTimedout);
    } finally {
        clearTimeout(timeoutId);
    }

    return undefined;
};

export default makeRequest;
